type routeParam = string | number;
export const __RoutePath = {
    register: {
        signIn: {
            index: '/register/',
            form: '/register/signin/',
            password: '/register/forget-password/',
            connectServer: '/register/connect-server/',
        },
    },
    dashboard: {
        index: '/dashboard',
        notification: '/dashboard/notification/',
        userDetail: '/dashboard/profile/user-detail/',
        loginDetail: '/dashboard/profile/login-detail/',
        publishList: '/dashboard/publishes/',
        publishDetail: (publish: routeParam, form: routeParam) => `/dashboard/publishes/${publish}/${form}/`,
        // formDetail: (form: routeParam) => `/dashboard/forms/${form}/`,
        wsDetail: (wsId: routeParam) => `/dashboard/workspace/${wsId}/`,
        slp: (publish: routeParam, form: routeParam) => `/dashboard/publishes/${publish}/${form}/slp`,
        answerList: (publish: routeParam, form: routeParam) => `/dashboard/publishes/${publish}/${form}/answers/`,
        answerDetail: (publish: routeParam, form: routeParam, answer: routeParam) =>
            `/dashboard/publishes/${publish}/${form}/${answer}/`,
        formAnswerList: (form: routeParam) => `/dashboard/forms/${form}/answers/`,
        formAnswerDetail: (form: routeParam, answer: routeParam) => `/dashboard/forms/${form}/answers/${answer}/`,
        answerEdit: (publish: routeParam, form: routeParam, answer: routeParam) =>
            `/dashboard/publishes/${publish}/${form}/${answer}/edit/`,
        learn: '/dashboard/learn/',
        support: '/dashboard/support/',
        aboutUs: '/dashboard/aboutus/',
        profile: {
            index: '/dashboard/profile/',
            userDetail: '/dashboard/profile/user-detail/',
            loginDetail: '/dashboard/profile/login-detail/',
            changePassword: '/dashboard/profile/change-password/',
        },
    },
};
